module.exports = __webpack_public_path__ + "static/media/logo-wechat-200.2ef3f369.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/tech-stack/logo-wechat-200.svg
// module id = 63
// module chunks = 0